import { render, staticRenderFns } from "./LinkedinAuth.vue?vue&type=template&id=b27a249c&scoped=true"
import script from "./LinkedinAuth.vue?vue&type=script&lang=js"
export * from "./LinkedinAuth.vue?vue&type=script&lang=js"
import style0 from "./LinkedinAuth.vue?vue&type=style&index=0&id=b27a249c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27a249c",
  null
  
)

export default component.exports